import { FormControl, FormErrorMessage, FormLabel, Input, chakra } from '@chakra-ui/react';
import React, { useEffect, useState } from 'react';
import { RegisterOptions, useFormContext } from 'react-hook-form';

interface FloatingLabelInputProps {
  name: string;
  marginTop?: number;
  label: string;
  type?: string;
  placeholder?: string;
  registerOptions?: RegisterOptions;
  errorMessage?: string;
}

const FloatingLabelInput: React.FC<FloatingLabelInputProps> = ({
  name,
  label,
  marginTop = 0,
  type = 'text',
  placeholder = ' ',
  registerOptions = {},
  errorMessage = 'Veuillez entrer une valeur valide',
}) => {
  const {
    register,
    watch,
    formState: { errors, isSubmitting },
  } = useFormContext();
  const value = watch(name); // Observez la valeur du champ d'entrée
  const isError = !!errors[name];
  const [isFilledOrFocused, setIsFilledOrFocused] = useState(false);

  useEffect(() => {
    // Pour les champs de type "date", considérez-les toujours comme remplis ou focalisés
    setIsFilledOrFocused(type === 'date' ? true : !!value);
  }, [value, type]);

  return (
    <FormControl isInvalid={isError}>
      <chakra.div maxW={400} position="relative" className="floating-label-input" marginTop={marginTop}>
        <Input
          {...register(name, registerOptions)}
          type={type}
          placeholder={placeholder}
          _focus={{ borderColor: 'primary' }}
          isDisabled={isSubmitting}
        />
        <FormLabel
          position="absolute"
          left="0"
          top="0"
          color="gray.500"
          pointerEvents="none"
          mx="2"
          px="1"
          bg="transparent"
          transformOrigin="left top"
          transform={isError || isFilledOrFocused ? 'scale(0.85) translateY(-24px)' : 'scale(1)'}
          _focus={{ transform: 'scale(0.85) translateY(-24px)' }}
          transition="transform 0.2s ease-out"
        >
          {label}
        </FormLabel>
      </chakra.div>
      <FormErrorMessage>{isError ? <>{errors[name]?.message || errorMessage}</> : null}</FormErrorMessage>
    </FormControl>
  );
};

export default FloatingLabelInput;
